var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddviewmeetingicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.5C14.4375 10.5 10.5 14.4375 10.5 19.25C10.5 24.0625 14.4375 28 19.25 28C24.0625 28 28 24.0625 28 19.25C28 14.4375 24.0625 10.5 19.25 10.5ZM19.25 26.25C15.4 26.25 12.25 23.1 12.25 19.25C12.25 15.4 15.4 12.25 19.25 12.25C23.1 12.25 26.25 15.4 26.25 19.25C26.25 23.1 23.1 26.25 19.25 26.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 26.25H0V28H10.5V26.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 0H21.875V1.75H17.7625V0H16.0125V1.75H11.9875V0H10.2375V1.75H6.125V0H4.375V1.75H0V24.5H8.75V22.75H1.75V3.5H4.375V5.25H6.125V3.5H10.2375V5.25H11.9875V3.5H16.0125V5.25H17.7625V3.5H21.875V5.25H23.625V3.5H26.25V9.625H28V1.75H23.625V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 14.875H4.375V16.625H6.125V14.875Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 18.375H4.375V20.125H6.125V18.375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 11.375H4.375V13.125H6.125V11.375Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 7.875H7.875V9.625H9.625V7.875Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11.375H7.875V13.125H9.625V11.375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.875H11.375V9.625H13.125V7.875Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.875H17.5V21H23.625V19.25H19.25V14.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddviewmeetingicon);
export default __webpack_public_path__ + "static/media/addviewmeetingicon.04fd98c54237e90715425656d550dd13.svg";
export { ForwardRef as ReactComponent };